export default __webpack_public_path__ + "static/media/logo-500px-200px.7d28c7ec.png";